var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubwallet = function SvgSubwallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#subwallet_svg__a)",
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#subwallet_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.3 6.61V5.22L5.8 3l-1.1.56v4.31l4.18 1.67-2.22.95v-.73l-1.02-.42-.94.44v2.64l1.1.56 5.5-2.5V8.7L6.38 6.71V5.49l3.96 1.59.96-.47Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subwallet_svg__a",
    x1: 0,
    x2: 15.967,
    y1: 0,
    y2: 15.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#61FEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0425FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "subwallet_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.7 3h6.6v10H4.7z"
  })))));
};
export default SvgSubwallet;